const jQ = jQuery.noConflict();
function fixedSocial() {
    if (document.querySelector('.container-share-links') !== null) {
        const pageContent = document.querySelector('.post-content');
        const socialWrapper = document.querySelector('.container-share-links');
        const social = document.querySelector('.social-media-wrapper--sticky-share');
        const socialHeight = social.offsetHeight;
        const stopItem = document.querySelector('.post-end');

        const stopItemTop = jQ('.post-end').offset().top;
        // stopItemTop = stopItem.offsetTop;
        function getFixed() { //eslint-disable-line
            const header = document.querySelector('.main-header');
            const headerHeight = header.offsetHeight;
            const diff = window.pageYOffset + socialHeight + 155 + headerHeight;
            const absolute = pageContent.offsetHeight - stopItem.offsetHeight - socialHeight;
            const pageOffset = pageContent.offsetTop - headerHeight;

            if (window.pageYOffset >= pageOffset) {
                socialWrapper.style.position = 'fixed';
                socialWrapper.style.height = `${socialHeight}px`;
                socialWrapper.style.top = `${headerHeight + 68}px`;
                socialWrapper.classList.remove('absolute');
                socialWrapper.classList.add('fixed');
            } else {
                socialWrapper.removeAttribute('style');
                socialWrapper.classList.remove('fixed');
            }

            if (diff >= stopItemTop) {
                socialWrapper.classList.remove('fixed');
                socialWrapper.classList.add('absolute');
                socialWrapper.style.position = 'absolute';
                socialWrapper.style.width = '100%';
                socialWrapper.style.top = `${absolute}px`;
            }
        }
        window.addEventListener('scroll', getFixed);
    }
}

export default fixedSocial;
